/**
 * Converts a base64 data URL string into a native File object
 */
export function dataURLtoFile(dataUrl: string, filename: string): File | null {
  if (!dataUrl || !dataUrl.startsWith('data:')) {
    return null // guard against non-data URIs (e.g. 'blob:')
  }

  try {
    const arr = dataUrl.split(',')
    const mimeMatch = arr[0].match(/:(.*?);/)
    const mime = mimeMatch ? mimeMatch[1] : 'image/png'
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
  } catch (e) {
    
    return null
  }
}
